
// WarningPopupWindow.js
import { useRef } from "react";
import { Box, Button, Layer, Header, Text, Image, grommet, Grommet } from "grommet";
import { Alert } from "grommet-icons";
import { deepMerge } from "grommet/utils";
import useTrapFocus from "../Utils/useTrapFocus";


const customTheme = deepMerge(grommet, {
    global: {
      colors: {
        brand: "#ed9e15",   // Goldenrod 
        text: "#ed9e15",
        border: "#ed9e15",
        selected: "light-4",
        
      },    
    },

  });

// component to show alert
const WarningPopupWindow = (props)=>{

    // Ref for the modal and focus trap to keep focus within it  
    const modalRef = useRef(null);
    useTrapFocus(modalRef, true); // Trap focus inside the modal while it's open

    return (
        <Grommet theme={customTheme} >
        <Layer
            id="warning-msg"
            ref={modalRef}
            tabIndex="-1"
            position="center"
            modal
            style={{
                backgroundColor: 'rgba(0, 0, 0, 0.5)', // Dim background for modal effect
            }}
        >
            <Box 
                overflow='auto'
                pad="small" 
                gap="small" 
                width="medium"  
                background="white"  
                
                style={{
                    position: 'relative',
                    margin: 'auto', // Center horizontally and vertically
                }}
            >
                <Box
                    pad="small" // Padding to create space for the white border
                    background="#fcf7e1" // White border
                    border={{ color: "brand"}}
                    >
                    <Box style={{position:"relative"}}>
                        <Header margin="none" background="#fae6c5" pad="small" height="xxsmall" justify="around">
                            <Text alignSelf="start" size="large"  align="center" >
                                <strong>Warning</strong>
                            </Text>
                        </Header>
                        <Box height="xsmall" width="xsmall"  
                            style={{position:"absolute", right: "3%", top: "15px"}}
                            right="0px"
                            >
                                <Image
                                    size="contain"
                                    src="Grape.png"                                  
                                />
                        </Box>                 
                    </Box>

                    <Box align="center" margin={{top: 'medium'}}>
                        <Alert color="brand" size='xlarge'/>
                        <Text  margin="large" textAlign="center" ><span style={{whiteSpace: 'pre-line'}}><strong>{props.msg}</strong></span></Text>
                    </Box>
                    <Box
                        as="footer"
                        gap="small"
                        direction="row"
                        align="center"
                        justify="end"
                        pad={{ top: 'medium', bottom: 'small' }}
                    >
                        <Button
                            label={
                            <Text color="white">
                                <strong>Ok</strong>
                            </Text>
                            }
                            onClick={props.close}
                            primary                  
                        />                                
                    </Box>
                </Box>
            </Box>
        </Layer>
        </Grommet>
    )
};

export default WarningPopupWindow;
